import { computed } from 'vue';
import i18n from '@/plugins/i18n';

import { PartnerRequest } from '@/components/user/models/user';
import { PARTNER_REQUEST } from '@/components/user/constants';

// @ts-expect-error not typed yet
import { useStore } from '@/store/index.js';
// @ts-expect-error not typed yet
import { userPartnerRequest } from '@/components/user/api.js';
// @ts-expect-error not typed yet
import notify from '@/components/base-components/components/notification/notify';

export default function usePartnerRequest() {
    const vuex = useStore();

    const state = computed<PartnerRequest>(() => vuex.getters['user/getPartnerRequest']);

    async function request() {
        if (state.value !== PARTNER_REQUEST.NOT_SENT) return;

        await vuex.dispatch('loader/SHOW');

        try {
            await userPartnerRequest();

            vuex.commit('user/SET_PARTNER_REQUEST', PARTNER_REQUEST.SENT);

            notify.success({
                title: i18n.t('request success notification'),
                message: i18n.t('partner request message'),
            });
        } catch {
            notify.error(i18n.t('tmp An error occurred'));
        } finally {
            await vuex.dispatch('loader/HIDE');
        }
    }

    return {
        state,
        request,
    };
}
